import { lazy } from 'react';
export var AgentProfileCardLazy = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_lazy-agent-profilecard" */
  './AgentProfileCard');
});